module.exports = __webpack_public_path__ + "img/emoji_06.069a02de.png";